// extracted by mini-css-extract-plugin
export default {"GridContainer":"ZDzzP4jCcvdZ2_y_HIZw","Container":"w1QvXMejypvxGHzo1E7i"};